import { BarChart3, Percent, Clock } from "lucide-react";
import { useAnalyticsOverview } from "@/hooks/useAnalyticsOverview";
import { StatCard } from "@/components/dashboard/StatCard";

const EMPTY = "—";

export function AnalyticsPage() {
  const { data, isLoading, isError } = useAnalyticsOverview();

  const completionRate = data?.completionRate ?? null;
  const avgDurationSeconds = data?.avgDurationSeconds ?? null;

  const completionDisplay =
    completionRate === null ? EMPTY : `${Math.round(completionRate * 100)} %`;
  const avgDurationDisplay =
    avgDurationSeconds === null ? EMPTY : `${Math.round(avgDurationSeconds)} s`;

  const hasResult = !isLoading && !isError;
  const completionEmpty = hasResult && completionRate === null;
  const avgDurationEmpty = hasResult && avgDurationSeconds === null;

  return (
    <div>
      <h1 className="text-2xl font-bold">Analytics</h1>
      <p className="mt-2 text-muted-foreground">
        Kennzahlen der letzten 30 Tage.
      </p>

      <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-4">
        <StatCard
          title="Quiz-Sessions"
          value={data?.sessions.last30d ?? 0}
          icon={BarChart3}
          description="Letzte 30 Tage"
          isLoading={isLoading}
          isError={isError}
        />
        <div
          {...(completionEmpty
            ? {
                role: "group",
                "aria-label": "Completion-Rate: keine Daten im Zeitraum",
              }
            : {})}
        >
          <StatCard
            title="Completion-Rate"
            value={completionDisplay}
            icon={Percent}
            description="Letzte 30 Tage"
            isLoading={isLoading}
            isError={isError}
          />
        </div>
        <div
          {...(avgDurationEmpty
            ? {
                role: "group",
                "aria-label":
                  "Durchschnittliche Dauer: keine Daten im Zeitraum",
              }
            : {})}
        >
          <StatCard
            title="Durchschnittliche Dauer"
            value={avgDurationDisplay}
            icon={Clock}
            description="Letzte 30 Tage"
            isLoading={isLoading}
            isError={isError}
          />
        </div>
      </div>
    </div>
  );
}
